import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { Filtro } from '../models/filtro';
import { TemplateEmail } from '../models/template-email';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { TemplateEmailService } from '../services/template-email.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-template-email',
  templateUrl: './template-email.component.html',
  styleUrls: ['./template-email.component.scss']
})
export class TemplateEmailComponent implements OnInit, OnDestroy {
  // variáveis
  templatesFiltrados: TemplateEmail[] = [];
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(private templateEmailService: TemplateEmailService, private utilitarioService: UtilitarioService,
    private router: Router, private paginatorService: PaginatorService, private route: ActivatedRoute,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
    
    this.buscarTemplates();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarTemplates();
    this.paginator.firstPage();
  }

  buscarTemplates() {
    this.carregandoService.mostra('buscaTemplates');
    this.carregando = true;

    this.templateEmailService.consultarCadenciasComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
      this.templatesFiltrados = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscaTemplates');
    }, (erro) => {
      this.carregandoService.esconde('buscaTemplates');
      this.notificacaoService.erro(erro);
    });
  }

  novoTemplateEmail() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarTemplateEmail(templateEmail: TemplateEmail) {
    this.router.navigate(['editar', templateEmail.id], { relativeTo: this.route });
  }

  excluirTemplateEmail(templateEmail: TemplateEmail) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja reamente excluir o Modelo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiTemplateEmail');
        this.templateEmailService.excluir(templateEmail.id).subscribe(resp => {
          this.notificacaoService.sucesso('Modelo excluído com sucesso!!!');
          this.carregandoService.esconde('excluiTemplateEmail');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluiTemplateEmail');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarTemplates();
  }

  ngOnDestroy(): void {}
}